import type { RegisteredServices } from '@/core/container/types'

import type BaseFieldModel from '@/data/models/forms/BaseFieldModel'
import type { FieldValue } from '@/data/models/forms/types'
import type { CSSProperties } from '@/composition/vue/compositionApi'

// TmSidebarFormLine props
export type SidebarFormLineProps = {
  fieldName: string
  isFocused: boolean
  isChanged: boolean
  isLoading: boolean
  label?: string
  searchQuery?: string
  hideButtons?: boolean
  contentLabelStyleList?: CSSProperties
}

// TmSidebarFormField props
export type SidebarFormFieldProps = {
  fieldName: string
  formId?: RegisteredServices
  isFrozen?: boolean
  readonly?: boolean
  label?: string
  searchQuery?: string
  placeholder?: string
  noPreview?: boolean
  hideButtons?: boolean
  contentLabelStyleList?: CSSProperties
  onBeforeSubmit?: (fieldValue: FieldValue) => Promise<boolean>
  getFieldValue?: (field: BaseFieldModel) => FieldValue
}

export type SidebarFormFieldSlotProps = {
  placeholder?: string
  formId: RegisteredServices
  formField: BaseFieldModel
  fieldName: string
  fieldValue: FieldValue
  searchQuery?: string
  isFrozen: boolean
  isFocused: boolean
  isLoading: boolean
  readonly?: boolean
  onFocus?: () => void
  onBlur?: () => void
  onCancel: () => void
  onSubmit: () => Promise<boolean>
}

// TmSidebarFormFieldPreview props
export type SidebarFormFieldPreviewProps = Pick<
  SidebarFormFieldSlotProps,
  'fieldValue' | 'isFrozen' | 'readonly' | 'isLoading' | 'searchQuery' | 'placeholder' | 'onFocus'
>

export const formLineContentLabelClassName = 'tm-sidebar-form-line__content__label'

export const formLineFocusedClassName = 'tm-sidebar-form-line--focused'

export const sidebarFormConfirmedFocus = 'sidebarFormConfirmedFocus'

export const sidebarFormUnconfirmedFocus = 'sidebarFormUnconfirmedFocus'
